import HoverRoomExport from '../src/components/HoverRoom';

export const HoverRoom = HoverRoomExport;
